export default function AuthExpired() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="text-center">
        <div className="text-6xl mb-4">&#9200;</div>
        <h1 className="text-3xl font-bold text-yellow-400 mb-4">
          Link Expired
        </h1>
        <p className="text-gray-400 max-w-md">
          This magic link has expired. Please request a new link to access the
          review.
        </p>
      </div>
    </div>
  );
}
